<template>
  <v-container fluid grid-list-lg>
    <!-- <ParentInvoiceCreate :createDialog="createParentInvoiceDialog" @close="createParentInvoiceDialog = false"
      @submit="invoiceCreated" :parent="selectedCustomer"></ParentInvoiceCreate> -->

    <v-card :loading="loading" outlined>
      <ListTitle :showBackButton="false" :access="false" :title="`${Customer.length} Customer`">

      </ListTitle>

      <v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
              hide-details clearable></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex sm4>
            <!-- <v-select
              :items="items"
              v-model="value"
              label="label"
            ></v-select> -->
            <DateTimePicker defaultRange="thisMonth" :range="true" v-model="selectedDate" @submit="getList()" />
          </v-flex>
          <v-flex shrink>
            <v-btn @click="createAllInvoice" :loading="loadingInvoice" color="success">Create All Invoice</v-btn>
          </v-flex>
        </v-layout>
        <!-- <v-spacer></v-spacer>
        <v-flex shrink>
          <v-btn class="mt-2" color="primary" @click="createParentInvoiceDialog = !createParentInvoiceDialog">New
            Invoice
          </v-btn>
        </v-flex> -->
      </v-card-title>
      <v-data-table class="pageHeight" :headers="headers" :items="Customer" :search="search" :loading="loading"
        :sort-by="sortBy" :page.sync="page" hide-default-footer :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-center" @click="viewProfile(item)">{{ item.id }}</td>
            <td class="text-left" @click="viewProfile(item)">
              <span class="text-capitalize">{{ item.name }}</span>


            </td>
            <td class="text-right" @click="viewProfile(item)">
              {{ item.balance | currency }}


            </td>
            <td align="right">
              <v-btn class="text-right" :loading="loadingBtn" color="primary" @click="createSingleInvoice(item)">New
                Invoice
              </v-btn>
            </td>


          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
      <v-dialog v-model="dialog" persistent max-width="300px">
        <v-card grid-list-md>
          <ModelTitle title="Student Fee Invoice" @close="close()" />
          <v-card-text>
            <v-col cols="12" sm="12">
              <DateSelector v-model="selectedInvoiceDate" :initValue="selectedInvoiceDate" />
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" text @click="close()">Close</v-btn>
            <v-btn color="primary" :loading="loading" dark @click="submit()">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import customerService from "@/modules/Customer/service.js";
// const ParentInvoiceCreate = () => import("@/modules/Customer/components/ParentInvoiceCreate.vue");
const DateTimePicker = () => import("@/components/DateTimePicker");
import studentService from "@/modules/Student/service.js";
import invoiceService from "@/modules/Invoice/service.js";
import settingService from "@/modules/Setting/service.js";
import DateSelector from "@/components/DateSelector";
import { mapGetters } from 'vuex';

export default {
  name: "no-invoice-list",
  data() {
    return {
      selectedInvoiceDate: new Date(),
      selectedInvoice: null,
      selectedDate: null,
      singleInvoice: false,
      dialog: false,
      loadingInvoice: false,
      loading: false,
      Customer: [],
      createParentInvoiceDialog: false,
      search: null,
      page: 1,
      sortBy: "id",
      pageCount: 0,
      Invoice: {
        date: this.$moment().toISOString(),
      },
      loadingBtn: false,
      Students: [],
      sortDesc: false,
      selectedCustomer: null,
      itemsPerPage: 10,
      Setting: null,
      headers: [
        {
          text: "ID",
          value: "id",
          sortable: true,
          align: "center",
        },
        {
          text: "Name",
          value: "name",
          sortable: true,
          align: "left",
        },
        {
          text: "Balance",
          value: "balance",
          sortable: true,
          align: "right",
        },
        {
          text: "Action",
          value: "id",
          sortable: false,
          align: "center",
        },
      ]
    }
  },
  components: {
    // ParentInvoiceCreate,
    DateTimePicker,
    DateSelector,
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },
  created() {
    // this.setMonths();
    // this.getList()
    return settingService.getById(this.currentBusiness.id).then((result) => {
      this.Setting = result.data;
    });
  },
  methods: {
    close() {
      this.dialog = !this.dialog
    },
    setMonths() {
      var startDate = this.$moment();
      var endDate = this.$moment(startDate).subtract(12, 'M');
      var month = this.$moment(startDate); //clone the startDate
      while (month > endDate) {
        this.dates.push({
          date: month.format('YYYY-MM-DD'),
          name: this.$moment(month).format('MMMM YYYY')
        });
        month.subtract(1, "month");
      }
      // console.log(this.dates);
      this.selectedDate = this.dates[0]
      this.getList();
    },
    viewProfile(val) {
      this.$router.push({ path: `/parents/${val.id}/profile` });
    },
    createAllInvoice() {
      console.log('Customer Array:', this.Customer);
      if (!this.Setting.metadata.defaultDay || !this.Setting.metadata.defaultProduct) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
          })
          .fire({
            icon: "error",
            title: 'Default product is not set. Check the setting and try again '
          });
        return false
      }

      const d = new Date();
      d.setDate(this.Setting.metadata.defaultDay.id);
      console.log('d', d)

      this.selectedInvoiceDate = this.$moment(d).toISOString()
      console.log('this.selectedInvoiceDate', this.selectedInvoiceDate)
        this.dialog = !this.dialog
      // for (let index = 0; index < this.Customer.length; index++) {
      //   const customer = this.Customer[index];
      //   console.log('customer', customer.id)
      //   await this.createInvoice(customer, true)
      // }
      // this.getList()
    },
    async submit() {
      if (this.singleInvoice) {
        this.createInvoice(this.selectedInvoice)
      } else {
        for (let index = 0; index < this.Customer.length; index++) {
          const customer = this.Customer[index];
          console.log('customer', customer.id)
          await this.createInvoice(customer, true)
        }
        this.getList()
      }

    },
    reset() {
      this.selectedInvoice = null
      this.singleInvoice = false
      this.dialog = !this.dialog
    },
    getPrice(setting) {
      return setting.parentPay + setting.charity
    },
    createSingleInvoice(val) {
      this.selectedInvoice = val
      this.singleInvoice = true
      this.dialog = !this.dialog
    },
    async createInvoice(item, all = false) {
      // console.log('ite.', item.id, this.Setting)
      try {
        this.loadingBtn = true
        this.selectedCustomer = (await customerService.getById(item.id)).data
        // console.log('selectedCustomer.', this.selectedCustomer)
        this.Students = (await studentService.getAll({ CustomerId: this.selectedCustomer.id, hideLeft: true })).data
        console.log('Students.', this.Students)
        if (this.Students.length === 0 ){
          this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "warning",
                title: `No Students found in ${this.selectedCustomer.fatherName} account.`,
              });
              this.loadingBtn = false;
              this.dialog = false;
              return false;
          

        }
        this.Invoice.CustomerId = this.selectedCustomer.id


        let detail = []
        this.Students.map(student => {
          let studentRow = {
            ProductId: this.Setting.metadata.defaultProduct.id,
            name: `${this.Setting.metadata.defaultProduct.name} - Parent Pay: ${student.ClassStudents[0].parentPay}`,
            price: this.getPrice(student.ClassStudents[0]),
            total: this.getPrice(student.ClassStudents[0]),
            parentPay: student.ClassStudents[0].parentPay,
            StudentId: student.id,
            qty: 1,
            cost: 0,
          }
          if (student && student.ClassRoomStudents.length) {
            studentRow.ClassRoomId = student.ClassRoomStudents[0].ClassRoomId
          }

          if (student && student.ClassStudents.length) {
            studentRow.ClassId = student.ClassStudents[0].Class.id
          }

          detail.push(studentRow)
        })

        this.Invoice.InvoiceDetails = detail

        this.Invoice.date = this.selectedInvoiceDate
        this.Invoice.dueDate = this.$moment(this.selectedInvoiceDate).add(4, 'days');
        // console.log('invoice', this.Invoice)
        this.loadingBtn = false
        return invoiceService
          .create(this.Invoice)
          .then(() => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: `Invoice was created for ${this.selectedCustomer.fatherName} for ${this.Students.length} students.`,
              });
            if (!all) {
              this.getList()
            }
            this.reset()
            this.loadingBtn = false
          })
          .catch((error) => {
            this.loadingBtn = false
            console.log("error creating invoice", error);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 6000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      } catch (error) {
        console.log('error', error)
        this.loadingBtn = false
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
          })
          .fire({
            icon: "error",
            title: error,
          });
      }

    },
    // invoiceCreated() {
    //   this.createParentInvoiceDialog = !this.createParentInvoiceDialog
    //   this.getList()
    // },
    getList() {
      this.loading = true;
      this.editDialog = false
      this.createDialog = false
      let where = this.selectedDate
      // if (this.CustomerId) {
      //   where.CustomerId = this.CustomerId;
      // }
      // if (this.ClassId) {
      //   where.ClassId = this.ClassId;
      // }
      console.log("where", where);
      return customerService.getAllNoInvoice(where).then((response) => {
        console.log('response', response)
        this.loading = false;
        this.Customer = response.data;
        this.itemsPerPage = this.Customer.length

      });
    },
  }
}
</script>

<style scoped></style>